<template>
	<div class="relative flex flex-col items-center">
		<div v-if="showOptions" class="absolute bottom-7 bg-gray-200 dark:bg-gray-800 p-1 rounded-full flex flex-col items-center gap-2">
			<button type="button" class="rounded-full size-6 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-900" @click.stop="switchToLight">
				<i class="fa-solid fa-sun"/>
			</button>
			<button type="button" class="rounded-full size-6 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-900" @click.stop="switchToDark">
				<i class="fa-solid fa-moon"/>
			</button>
			<button type="button" class="rounded-full size-6 flex items-center justify-center hover:bg-gray-100 dark:hover:bg-gray-900" @click.stop="prefersOS">
				<i class="fa-solid fa-circle-half-stroke"/>
			</button>
		</div>
		<button type="button" class="rounded-full size-6 flex items-center justify-center" @click.stop="showOptions = !showOptions">
			<i v-if="theme === 'light'" class="fa-solid fa-sun"/>
			<i v-if="theme === 'dark'" class="fa-solid fa-moon"/>
			<i v-if="theme === 'os'" class="fa-solid fa-circle-half-stroke"/>
		</button>
	</div>
</template>
<script setup lang="ts">
import {ref, type Ref} from 'vue'

const theme:Ref<string> = ref(localStorage.theme ?? 'os')
const showOptions:Ref<boolean> = ref(false)

function switchToLight():void{
	theme.value = localStorage.theme = 'light'
	document.documentElement.classList.remove('dark')
}

function switchToDark():void{
	theme.value = localStorage.theme = 'dark'
	document.documentElement.classList.add('dark')
}

function prefersOS():void{
	if(window.matchMedia('(prefers-color-scheme: dark)').matches){
		switchToDark()
	} else {
		switchToLight()
	}
	theme.value = 'os'
}
</script>